import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router';

import { FullScreenLoaderComponent } from 'baseComponents/FullScreenLoaderComponent';
import { useAuthStoreActions } from 'store/AuthStore';

export const LoadingScreen: React.FC = () => {
  const { setTokens, setLoggedIn } = useAuthStoreActions();
  const navigate = useNavigate();

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const accessToken = queryParams.get('access_token');
  const refreshToken = queryParams.get('refresh_token');

  useEffect(() => {
    if (accessToken && refreshToken) {
      setTokens({
        access_token: accessToken,
        refresh_token: refreshToken,
      });
      setLoggedIn(true);

      const redirectTo = location.state?.from?.pathname || '/home';
      navigate(redirectTo, { replace: true });
    } else {
      const redirectTo = '/';

      navigate(redirectTo, { state: 'error', replace: true });
    }
    // eslint-disable-next-line
  }, []);

  return <FullScreenLoaderComponent spinning />;
};
